module.exports = __webpack_public_path__ + "img/icon-left-top.798b44d2.png";